import { MatchStatus } from "../../service";
import { LANGUAGE } from "_constants";
import { MESSAGES } from "./constants";

export type TennisTabKey = "narration" | "stats";

export const TENNIS_TABS: { key: TennisTabKey; label: string }[] = [
  { key: "narration", label: "Narration" },
  { key: "stats", label: "Statistics" },
];

const isAwayFromCode = (status: MatchStatus) => {
  if (!status.sc || status.sc.length < 5) return undefined;
  if (status.sc.startsWith("2")) return true;
  if (status.sc.startsWith("1")) return false;
  return undefined;
};

export const getActiveTeamName = (status: MatchStatus) => {
  const isAway = isAwayFromCode(status);

  const homeName =
    (status as any)?.T1?.n ??
    (status as any)?.t1?.n ??
    (status as any)?.T1n ??
    null;
  const awayName =
    (status as any)?.T2?.n ??
    (status as any)?.t2?.n ??
    (status as any)?.T2n ??
    null;

  if (isAway === undefined) return null;
  return isAway ? awayName : homeName;
};

export const processStatus = (status: MatchStatus, language: LANGUAGE) => {
  const normalizedStatusCode = status.sc?.slice(-4);
  const messageDict = MESSAGES[language];

  const message = normalizedStatusCode
    ? messageDict?.[normalizedStatusCode]?.toUpperCase?.()
    : undefined;

  return {
    normalizedStatusCode,
    message,
  };
};
